'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataGridCell", {
    enumerable: true,
    get: function() {
        return DataGridCell;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useDataGridCell = require("./useDataGridCell");
const _renderDataGridCell = require("./renderDataGridCell");
const _useDataGridCellStylesstyles = require("./useDataGridCellStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const DataGridCell = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDataGridCell.useDataGridCell_unstable)(props, ref);
    (0, _useDataGridCellStylesstyles.useDataGridCellStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDataGridCellStyles_unstable')(state);
    return (0, _renderDataGridCell.renderDataGridCell_unstable)(state);
});
DataGridCell.displayName = 'DataGridCell';
